module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.data !== null) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "fade-in-down"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Usuário")]), _vm._v(" "), _c('span', {
    staticClass: "label no-radius bg-dark"
  }), _vm._v(" "), _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-success"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "visible-xs m-t-lg"
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-info pull-right pull-none-xs hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.print($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print m-r-xs"
  }), _vm._v(" Imprimir\n            ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit m-r-xs"
  }), _vm._v(" Editar\n            ")]), _vm._v(" "), (_vm.ACL.check('excluir_usuario_intranet', _vm.currentUser.id)) ? _c('u-button', {
    staticClass: "btn btn-sm btn-default btn-danger pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deletar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit m-r-xs"
  }), _vm._v(" Deletar\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isAdministradorExclusivo && !_vm.data.bloqueado) ? _c('u-button', {
    staticClass: "btn btn-sm btn-default btn-danger pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.bloquearUsuario($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban m-r-xs"
  }), _vm._v(" Bloquear usuário\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isAdministradorExclusivo && _vm.data.bloqueado) ? _c('u-button', {
    staticClass: "btn btn-sm btn-default btn-danger pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.desbloquearUsuario($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban m-r-xs"
  }), _vm._v(" Desbloquear usuário\n            ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right pull-none-xs hidden-print m-t-xs m-r",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'usuarios'
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('btn-usuario-configuracoes-gerenciais', {
    staticClass: "pull-right pull-none-xs hidden-print m-r",
    attrs: {
      "user": _vm.data
    },
    on: {
      "openAtendenteReboquistaForm": _vm.openAtendenteReboquistaForm
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', [_vm._v(_vm._s(_vm.data.pessoa.nome))]), _vm._v(" "), _c('p', [_vm._v("Login: " + _vm._s(_vm.data.username))]), _vm._v(" "), _vm._l((_vm.enderecoPrincipal), function(endereco) {
    return _c('p', [_vm._v("\n              " + _vm._s(endereco.logradouro) + _vm._s(endereco.numero && ', ' + endereco.numero) + " " + _vm._s(endereco.complemento &&
      endereco.complemento) + " "), _c('br'), _vm._v("\n              " + _vm._s(endereco.bairro) + " " + _vm._s(endereco.cep ? ', ' + endereco.cep : '')), _c('br'), _vm._v("\n              " + _vm._s(endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros) + ", " + _vm._s(endereco.municipio &&
      endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros) + "\n            ")])
  }), _vm._v(" "), _vm._l((_vm.outrosEnderecos), function(endereco) {
    return _c('p', {
      staticClass: "b-t"
    }, [_vm._v("\n              " + _vm._s(endereco.logradouro) + _vm._s(endereco.numero && ', ' + endereco.numero) + " " + _vm._s(endereco.complemento &&
      endereco.complemento) + " "), _c('br'), _vm._v("\n              " + _vm._s(endereco.bairro)), _c('br'), _vm._v("\n              " + _vm._s(endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros) + ", " + _vm._s(endereco.municipio &&
      endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros) + "\n            ")])
  }), _vm._v(" "), _c('p', _vm._l((_vm.data.pessoa.telefones), function(telefone) {
    return _c('span', [_vm._v("Telefone: " + _vm._s(_vm._f("formataTelefone")(telefone.telefone))), (telefone.celular) ? _c('i', {
      staticClass: "fa fa-mobile-phone m-l-xs"
    }) : _vm._e(), _vm._v(" "), _c('br')])
  }), 0), _vm._v(" "), _c('p', [_vm._v("\n              Email principal: "), _c('span', [_vm._v(_vm._s(_vm.data.email))])]), _vm._v(" "), (_vm.data.pessoa.emails && _vm.data.pessoa.emails.length > 0) ? _c('p', [_vm._v("\n              Email" + _vm._s(_vm.data.pessoa.emails && _vm.data.pessoa.emails.length > 1 ? 's' : '') + ": "), _c('span', [_vm._v(_vm._s(_vm.getEmails))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n              IP origem cadastro: "), _c('span', [_vm._v(_vm._s(_vm.data.pessoa.ipCadastro))])]), _vm._v(" "), (_vm.data.pessoa.observacao) ? _c('p', [_vm._v("\n              Observações:"), _c('br'), _c('br'), _vm._v("\n              " + _vm._s(_vm.data.pessoa.observacao) + "\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right text-left-print"
  }, [_c('p', {
    staticClass: "h4"
  }, [_vm._v("#" + _vm._s(_vm.data.id))]), _vm._v(" "), _c('h5', [_vm._v("Se cadastrou" + _vm._s(_vm.data.pessoa.origem ? ' pelo ' + _vm.data.pessoa.origem.origem.toLowerCase() :
    '') + " " + _vm._s(_vm.moment(_vm.data.pessoa.dataCadastro.date).format('LLLL')))]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.data.pessoa.tipo === 1 ? 'Pessoa Física' : 'Pessoa Jurídica')), _c('br'), _vm._v(" "), (_vm.data.pessoa.tipo === 1) ? _c('div', [_vm._v("\n                CPF: "), (_vm.data.pessoa.cpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(_vm.data.pessoa.cpf)))]) : _c('span', [_vm._v("Sem CPF")]), _c('br'), _vm._v("\n                RG: " + _vm._s(_vm.data.pessoa.pfRg) + " " + _vm._s(_vm.data.pessoa.pfRgOrgaoEmissor) + " " + _vm._s(_vm.data.pessoa.pfRgDataExpedicao ? _vm.moment(_vm.data.pessoa.pfRgDataExpedicao.date).format('L') : '')), _c('br'), _vm._v("\n                Nascimento: "), (_vm.data.pessoa.pfDataNascimento) ? _c('span', [_vm._v(_vm._s(_vm.moment(_vm.data.pessoa.pfDataNascimento.date).format('L')) + ", " + _vm._s(_vm._f("moment")(_vm.data.pessoa.pfDataNascimento.date)))]) : _vm._e(), _c('br'), _vm._v("\n                Estado Civil: " + _vm._s(_vm.Status().EstadoCivil[_vm.data.pessoa.pfEstadoCivil])), _c('br'), _vm._v("\n                Sexo: " + _vm._s(_vm.data.pessoa.pfSexo === 1 ? 'Masculino' : 'Feminino')), _c('br'), _vm._v(" "), (_vm.data.conjugeNome) ? _c('div', [_vm._v("\n                  Cônjuge: " + _vm._s(_vm.data.conjugeNome)), _c('br'), _vm._v("\n                  CPF Cônjuge: "), (_vm.data.conjugeCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(_vm.data.conjugeCpf)))]) : _c('span', [_vm._v("Sem CPF")]), _c('br'), _vm._v("\n                  RG Cônjuge: "), (_vm.data.conjugeRg) ? _c('span', [_vm._v(_vm._s(_vm.data.conjugeRg))]) : _c('span', [_vm._v("Sem RG")]), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.data.pessoa.tipo === 2) ? _c('div', [_vm._v("\n                CNPJ: "), (_vm.data.pessoa.cnpj) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCnpj")(_vm.data.pessoa.cnpj)))]) : _c('span', [_vm._v("Sem CNPJ")]), _c('br'), _vm._v("\n                Inscrição Estadual: " + _vm._s(_vm.data.pessoa.pjInscricaoEstadual)), _c('br'), _vm._v("\n                Nome Fantasia: " + _vm._s(_vm.data.pessoa.pjNomeFantasia)), _c('br'), _vm._v("\n                Razão Social: " + _vm._s(_vm.data.pessoa.pjRazaoSocial)), _c('br'), _vm._v("\n                Responsável: " + _vm._s(_vm.data.pessoa.pjResponsavel || _vm.data.pjProprietarioNome)), _c('br'), _vm._v("\n                CPF: "), (_vm.data.pjProprietarioCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(_vm.data.pjProprietarioCpf)))]) : _c('span', [_vm._v("SEM CPF DO RESPONSÁVEL")])]) : _vm._e()])])]), _vm._v(" "), (_vm.showAtendenteReboquistaForm) ? _c('popup-viewer', {
    on: {
      "close": _vm.closeAtendenteReboquistaForm
    }
  }, [_c('AtendenteReboquistaForm', {
    attrs: {
      "user": _vm.data
    },
    on: {
      "finishSubmit": _vm.atualizaIdReboquista
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "shell-wrap"
  }, [_c('p', {
    staticClass: "shell-top-bar"
  }, [_vm._v("Sistema de Acesso")]), _vm._v(" "), _c('ul', {
    staticClass: "shell-body"
  }, [_c('li', [_vm._v("Login status: "), _c('span', {
    staticClass: "font-bold text-white"
  }, [_vm._v("Active")])]), _vm._v(" "), _c('li', [_vm._v("Username: "), _c('span', {
    staticClass: "font-bold text-white"
  }, [_vm._v(_vm._s(_vm.data.username))])]), _vm._v(" "), _vm._l((_vm.saLogs), function(m) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(m.message)
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.alterarSenha
    }
  }, [_vm._v("Alterar senha")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5584b6c1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/usuarios/components/VisualizarUsuario.vue
// module id = 1693
// module chunks = 17